// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rbt-close {
  font-size: 1rem;
}
.rbt-close-sm {
  font-size: 0.75rem;
}
.rbt-close-content {
  display: none;
}

.rbt-aux {
  width: 2.5rem;
}
.rbt-aux-lg {
  width: 3rem;
}
.rbt-aux .rbt-close {
  margin-top: 0;
}

.rbt .form-floating {
  flex: 1 1;
}

.form-floating > .rbt-input-multi:not(:placeholder-shown) ~ label {
  opacity: inherit;
  transform: inherit;
}
.form-floating > .rbt-input-multi .rbt-input-main::placeholder {
  color: transparent;
}
.form-floating > .rbt-input-multi.focus ~ label {
  opacity: 0.65;
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}`, "",{"version":3,"sources":["webpack://./node_modules/react-bootstrap-typeahead/css/Typeahead.bs5.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;AACf;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,8DAA8D;AAChE","sourcesContent":[".rbt-close {\n  font-size: 1rem;\n}\n.rbt-close-sm {\n  font-size: 0.75rem;\n}\n.rbt-close-content {\n  display: none;\n}\n\n.rbt-aux {\n  width: 2.5rem;\n}\n.rbt-aux-lg {\n  width: 3rem;\n}\n.rbt-aux .rbt-close {\n  margin-top: 0;\n}\n\n.rbt .form-floating {\n  flex: 1;\n}\n\n.form-floating > .rbt-input-multi:not(:placeholder-shown) ~ label {\n  opacity: inherit;\n  transform: inherit;\n}\n.form-floating > .rbt-input-multi .rbt-input-main::placeholder {\n  color: transparent;\n}\n.form-floating > .rbt-input-multi.focus ~ label {\n  opacity: 0.65;\n  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
